// ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii
import React, { useState, useEffect } from 'react';
import { InputNumber, Row, Col, Form, Input, Select } from 'antd';

import {
    PlusCircleOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    CloseCircleOutlined} from '@ant-design/icons';



const { Option } = Select;


export default function ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya(props) {
    const { auth, object } = props;
    const [prichina, setPrichina] = useState([]);

    useEffect(() => {
        auth.fetch('/api/query/Prichini?s-opisanie').then(res => {
            if (res && res.data) {
                setPrichina(res.data);
            }
        });
    }, []);

    const options = prichina.map(i => (
        <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>
    ));

    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                zasedanieRegionalnogoPravleniyaID: object.zasedanieRegionalnogoPravleniya.ID,
                voprosPovestkiDnyaZasedaniyaRegPravleniyaID: object.voprosPovestkiDnyaZasedaniyaRegPravleniyaID,
                resheniePoVoprosuPovestkiDnya: object.resheniePoVoprosuPovestkiDnya,
                za: object.za,
                protiv: object.protiv,
                vozderzhalsya: object.vozderzhalsya,
                neProgolosoval: object.neProgolosoval,
                prichinaID: object.prichinaID
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"zasedanieRegionalnogoPravleniyaID"}
                label={"Заседание регионального правления"}
                rules={[{ required: true, message: 'Укажите заседание регионального правления!' }]}
            >
                <Input disabled />
            </Form.Item>
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"voprosPovestkiDnyaZasedaniyaRegPravleniyaID"}
                label={"Вопрос повестки дня заседания правления федерации"}
                rules={[{ required: true, message: 'Укажите вопрос повестки дня заседания правления федерации!' }]}
            >
                <Input disabled />
            </Form.Item>
            {/* <Form.Item
                name={"voprosPovestkiDnya"}
                label={"Вопрос повестки дня"}
                rules={[{ required: true, message: 'Укажите вопрос повестки дня!' }]}
            >
                <TextArea disabled rows={4} />
            </Form.Item> */}
            <Form.Item
                name={"resheniePoVoprosuPovestkiDnya"}
                label={"Решение по вопросу повестки дня"}
                rules={[{ required: true, message: 'Укажите решение по вопросу повестки дня!' }]}
            >
                <Input />
            </Form.Item>

            <Row>
                <Col span={6} style={{paddingRight: "5px"}}>
                    <Form.Item
                        name={"za"}
                        label={<span><PlusCircleOutlined style={{ color: "green", paddingRight: "6px" }} />За</span>}
                        dependencies={['protiv', 'vozderzhalsya', 'neProgolosoval']}
                        rules={[
                            { required: true, message: 'Укажите количество за!' },
                            ({ getFieldValue }) => ({
                                validator() {
                                    var val = getFieldValue('za') + 
                                              getFieldValue('protiv') + 
                                              getFieldValue('vozderzhalsya') + 
                                              getFieldValue('neProgolosoval');
                                  if (val > object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya) {
                                    return Promise.reject('Общее число голосов не должно привышать '+object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya); 
                                  }                       
                                  return Promise.resolve();
                                },
                              }),
                        ]}
                    >
                        <InputNumber min={0} max={object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya} style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col span={6} style={{paddingRight: "5px", paddingLeft: "5px"}}>
                    <Form.Item
                        name={"protiv"}
                        label={<span><MinusCircleOutlined style={{ color: "red", paddingRight: "6px" }} />Против</span>}
                        dependencies={['za', 'vozderzhalsya', 'neProgolosoval']}
                        rules={[{ required: true, message: 'Укажите количество против!' },
                        ({ getFieldValue }) => ({
                            validator() {
                                var val = getFieldValue('za') + 
                                          getFieldValue('protiv') + 
                                          getFieldValue('vozderzhalsya') + 
                                          getFieldValue('neProgolosoval');
                              if (val > object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya) {
                                return Promise.reject('Общее число голосов не должно привышать '+object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya); 
                              }                                  
                              return Promise.resolve();
                            },
                          }),
                    ]}
                    >
                        <InputNumber min={0} max={object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya} style={{ width: "100%" }}  />
                    </Form.Item>
                </Col>
                <Col span={6} style={{paddingRight: "5px", paddingLeft: "5px"}}>
                    <Form.Item
                        name={"vozderzhalsya"}
                        label={<span><ExclamationCircleOutlined style={{ color: "orange", paddingRight: "6px" }} />Воздержался</span>}
                        dependencies={['za', 'protiv', 'neProgolosoval']}
                        rules={[{ required: true, message: 'Укажите количество воздержавшихся!' },
                        ({ getFieldValue }) => ({
                            validator() {
                                var val = getFieldValue('za') + 
                                          getFieldValue('protiv') + 
                                          getFieldValue('vozderzhalsya') + 
                                          getFieldValue('neProgolosoval');
                              if (val > object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya) {
                                return Promise.reject('Общее число голосов не должно привышать '+object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya); 
                              }                                  
                              return Promise.resolve();
                            },
                          }),
                    ]}
                    >
                        <InputNumber min={0} max={object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya} style={{ width: "100%" }}  />
                    </Form.Item>
                </Col>
                <Col span={6} style={{paddingLeft: "5px"}}>
                    <Form.Item
                        name={"neProgolosoval"}
                        label={<span><CloseCircleOutlined style={{ color: "grey", paddingRight: "6px" }} />Не проголосовал</span>}
                        dependencies={['za', 'protiv', 'vozderzhalsya']}
                        rules={[{ required: true, message: 'Укажите количество не проголосовавших!' },
                        ({ getFieldValue }) => ({
                            validator() {
                                var val = getFieldValue('za') + 
                                          getFieldValue('protiv') + 
                                          getFieldValue('vozderzhalsya') + 
                                          getFieldValue('neProgolosoval');
                              if (val > object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya) {
                                return Promise.reject('Общее число голосов не должно привышать '+object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya); 
                              }                                  
                              return Promise.resolve();
                            },
                          }),
                    ]}
                    >
                        <InputNumber min={0} max={object.zasedanieRegionalnogoPravleniya.kolichestvoPrisutstvuyushchikhChlenovPravleniya} style={{ width: "100%" }}  />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                name={"prichinaID"}
                label={"Причина"}
                rules={[{ required: true, message: 'Укажите причину!' }]}
            >
                <Select showSearch
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>

        </Form>
    );
}

            // //- Причина текст
            // // uuid: c41a88e-4bc-7cc2-3145-0f5ee1550a2
            // PrichinaTekst *string `json:"prichinaTekst" validate:"" gorm:"column:prichina_tekst;size:500;"`

            // //- Прием или исключение
            // // uuid: fe4f7ec-b035-8442-55ec-b62e3824d08a
            // PriemIliIsklyuchenie *bool `json:"priemIliIsklyuchenie" validate:"" gorm:"column:priem_ili_isklyuchenie;"`

            // //- Член федерации
            // // uuid: cce5ee0-cf63-b2b6-33d-abe26ba2b7
            // ChlenFederatsiiID *uint             `json:"chlenFederatsiiID" validate:"" gorm:""`
            // ChlenFederatsii   *ChleniFederatsii `json:"chlenFederatsii" gorm:"save_associations:false"`

            // //- Отделение
            // // uuid: 0136885-f4a0-e614-f4d1-8e868e21b6d
            // OtdelenieID *uint                  `json:"otdelenieID" validate:"" gorm:""`
            // Otdelenie   *RegionalnieOtdeleniya `json:"otdelenie" gorm:"save_associations:false"`

            // //- Вариант ответа для голосования
            // // uuid: b3d51d2-a6-131e-2118-7f6b248331e8
            // VariantOtvetaDlyaGolosovaniya *string `json:"variantOtvetaDlyaGolosovaniya" validate:"" gorm:"column:variant_otveta_dlya_golosovaniya;size:500;"`

            // //- Вопрос повестки дня
            // // uuid: 0718b62-0f7a-beb0-0db7-c4c3001dfbaa
            // VoprosPovestkiDnya *string `json:"voprosPovestkiDnya" validate:"" gorm:"column:vopros_povestki_dnya;size:500;"`

            // //- Количество присутствующих
            // // uuid: 8404280-feb0-607c-7ecc-6568e4a3505
            // KolichestvoPrisutstvuyushchikh *int `json:"kolichestvoPrisutstvuyushchikh" validate:"" gorm:"column:kolichestvo_prisutstvuyushchikh;"`

